<template>
  <!--Legende -->
  <div>
    <div
      class="
        fixed
        flex
        items-center
        inset-0
        z-[51]
        bg-base-300 bg-opacity-70
        animate-animated animate-zoomIn
      "
      v-if="modal"
      @click="modal = false"
    >
      <div
        @click.stop
        class="
          w-10/12
          max-h-[calc(90%-3rem)]
          mt-12
          mx-auto
          bg-base-100
          text-base-content
          card
        "
      >
        <div class="flex flex-col overflow-auto card-body">
          <div class="font-bold text-center card-title text-accent-focus">
            Rapport
          </div>

          <div class="flex-1 w-full overflow-auto">
            <table ref="datatable" class="w-full">
              <thead class="bg-base-300">
                <tr>
                  <th rowspan="2" class="">Risque liés</th>
                  <th
                    v-for="i in participations.length"
                    colspan="2"
                    class="text-center"
                    :key="i"
                  >
                    P{{ i }}
                  </th>
                  <th colspan="2" class="w-20">Total</th>
                  <th colspan="2" class="w-20">Moyen</th>
                </tr>

                <tr>
                  <template v-for="i in participations.length" :key="i">
                    <th class="w-8">P</th>
                    <th class="w-8">I</th>
                  </template>

                  <th class="w-12">P</th>
                  <th class="w-12">I</th>

                  <th class="w-12">P</th>
                  <th class="w-12">I</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(result, index) in items"
                  :key="index"
                  class="hover:bg-base-300"
                  :class="{
                    'bg-blue-100': index % 2 != 0,
                    'bg-base-100': index % 2 == 0
                  }"
                >
                  <th>{{ result.activityName }}</th>

                  <template v-for="j in participations" :key="j">
                    <td class="py-2 text-center text-accent-focus">
                      {{
                        j.find(x => x.activityID == result.activityID)
                          ?.facility || ""
                      }}
                    </td>

                    <td class="py-2 text-center border-r text-secondary">
                      {{
                        j.find(x => x.activityID == result.activityID)
                          ?.importance || ""
                      }}
                    </td>
                  </template>

                  <th>
                    {{
                      participations
                        .map(
                          tab =>
                            tab.find(
                              x => x.activityID == result.activityID
                            ) ?? { importance: 0, facility: 0 }
                        )
                        .map(x => x.facility)
                        .reduce((a, b) => a + b)
                    }}
                  </th>

                  <th>
                    {{
                      participations
                        .map(
                          tab =>
                            tab.find(
                              x => x.activityID == result.activityID
                            ) ?? { importance: 0, facility: 0 }
                        )
                        .map(x => x.importance)
                        .reduce((a, b) => a + b)
                    }}
                  </th>

                  <th>
                    {{
                      (
                        participations
                          .map(
                            tab =>
                              tab.find(
                                x => x.activityID == result.activityID
                              ) ?? { importance: 0, facility: 0 }
                          )
                          .map(x => x.facility)
                          .reduce((a, b) => a + b) /
                        participations
                          .map(tab =>
                            tab.find(x => x.activityID == result.activityID)
                          )
                          .filter(x => !!x).length
                      ).toFixed(2)
                    }}
                  </th>

                  <th>
                    {{
                      (
                        participations
                          .map(
                            tab =>
                              tab.find(
                                x => x.activityID == result.activityID
                              ) ?? { importance: 0, facility: 0 }
                          )
                          .map(x => x.importance)
                          .reduce((a, b) => a + b) /
                        participations
                          .map(tab =>
                            tab.find(x => x.activityID == result.activityID)
                          )
                          .filter(x => !!x).length
                      ).toFixed(2)
                    }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex justify-end mt-4">
            <button
              class="ml-auto btn btn-accent bg-accent-focus"
              @click="exportToExcel"
            >
              Exporter en Excel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="fixed left-0 z-50 w-64 p-0 mt-4 transition-all duration-500 rounded-l-none shadow-lg  2xl:w-96 bg-base-100 card top-32"
      :class="{
        'translate-x-[calc(-100%+2rem)] h-40 ': !openLegend,
        'translate-x-0  max-h-[calc(100vh-15rem)]': openLegend
      }"
    >
      <div
        :class="{
          'opacity-0 pointer-events-none': openLegend,
          'opacity-100 pointer-events-auto': !openLegend
        }"
        @click="openLegend = !openLegend"
        class="absolute right-0 flex items-center justify-between h-full py-4 text-2xl font-bold rotate-180  text-secondary-content bg-secondary"
        style="writing-mode: vertical-rl; text-orientation: mixed"
      >
        <span>Activités</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
          />
        </svg>
      </div>
      <div
        :class="{
          'opacity-0': !openLegend,
          'opacity-100': openLegend
        }"
        @click="openLegend = !openLegend"
        class="flex items-center justify-between px-2 py-1 text-2xl font-bold  gap-x-4 card-title bg-secondary text-secondary-content"
      >
        <span>Liste des activités</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
          />
        </svg>
      </div>
      <div
        class="max-h-full p-0 overflow-auto card-body"
        :class="{ hidden: !openLegend, block: openLegend }"
      >
        <div class="max-h-full">
          <template v-for="(result, index) in items" :key="index">
            <div
              @mouseover="$emit('itemhover', result)"
              @mouseleave="$emit('itemrelease')"
              class="flex items-center p-2 mt-1 mb-2 border-l-4 cursor-pointer  gap-x-2 rounded-l-xl hover:font-bold hover:border-l-8 ring-1 animate__animated animate__fadeInDown"
            >
              <div class="w-8">
                <div
                  class="flex items-center justify-center w-8 h-8 rounded-full  bg-primary text-primary-content"
                >
                  A{{ result.$id }}
                </div>
              </div>

              <div class="text-sm">{{ result.name }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="flex justify-center p-2">
        <button
          class="btn btn-sm btn-secondary"
          @click="getParticipations"
          :class="{ loading: loading }"
        >
          Analyse des contributions
        </button>
      </div>
    </div>
  </div>

  <!-- Fin  Legende -->
</template>

<script>
import XLSX from "xlsx";
import globalMixins from "@/utils/mixins/mixin.js";
export default {
  name: "ListeActivity",
  mixins: [globalMixins],
  props: {
    items: Array
  },
  data() {
    return {
      openLegend: true,
      modal: false,
      participations: [],
      loading: false
    };
  },
  methods: {
    mounted() {
      this.getParticipations();
    },
    exportToExcel() {
      var table = this.$refs.datatable;
      var wb = XLSX.utils.table_to_book(table, {
        sheet: "Participation Participant"
      });
      return XLSX.writeFile(wb, "ParticipationMP" + ".xlsx");
    },

    async getParticipations() {
      this.loading = true;
      try {
        var response = await this.$axios.get(
          "ParticipantsQueries/GetParticipantsContributionByFileID/" +
            this.currentFile.fileID
        );
        var participations = window._.groupBy(response.data, x => x.personID);

        this.participations = Object.entries(participations).map(x => x[1]);
        this.modal = true;
      } catch (error) {
        this.$swal.fire({
          title: "Impossible de traiter la démande actuellement",
          text: "Verifiez votre connexion puis réessayez",
          icon: "error"
        });
      }

      this.loading = false;
    }
  }
};
</script>

<style></style>
